import React from "react";
import HeaderBar from '../components/HeaderBar';
import PortfolioItem from '../components/PortfolioItem';

const Programs = () => {
    return (
        <div>
            <div className="fiery">
                <div className="lessnefarious">
                    Programs
                </div>
            </div>
            <PortfolioItem 
                imageurl="/assets/fire.gif" 
                title="This Website!" 
                description="My very own website built in-house in React. Hope you enjoy!" 
                link="/this" 
            />
            
            <PortfolioItem 
                imageurl="/assets/familytree/FamilyTree.png" 
                title="Family Tree Maker" 
                description="A GUI App that lays out a family tree as the user adds people to it! Made in Java." 
                link="/familytree" 
            />
            <PortfolioItem 
                imageurl="/assets/supersand/SuperSandThumbnail.jpg" 
                title="SuperSand" 
                description="A falling sand game I made for fun in C++ using SFML for the GUI." 
                link="/supersand" 
            />
            <PortfolioItem 
                imageurl="/assets/minesweeper/ms_3.jpg" 
                title="Parallel Minesweeper" 
                description="A program that solves a minesweeper game by offloading the work onto other computers! A showcase of networking and parallel programming made for my Parallel Programming university class." 
                link="/paramines" 
            />
            <PortfolioItem 
                imageurl="/assets/aquarium/fish_1.jpg" 
                title="Aquarium Simulator" 
                description="A Discrete Event Simulation with a custom-built framework, wrapped in an aquarium theme. Made for my Simulations and Digital Worlds university class." 
                link="/aquarium" 
            />
        </div>
    );
}

export default Programs;